export const clickOutside = (e, classTarget, className, buttonClass) => {
  const $target = $(e.target)
  const $targetParent = $target.closest(`.${classTarget}`)
  const checkClass = !$target.hasClass(classTarget) && !$targetParent.length

  if (buttonClass) {
    const checkBtnClass = !$target.hasClass(buttonClass) && !$target.closest(`.${buttonClass}`).length
    if (checkClass && checkBtnClass) {
      $(`.${classTarget}`).removeClass(className)
    } else {
      if (checkBtnClass) {
        $(`.${classTarget}`).not($targetParent).removeClass(className)
      }
    }
  } else if (checkClass) {
    $(`.${classTarget}`).removeClass(className)
  }
}
